export const TITLE =
  "¡Enviamos un correo a tu casilla!\nSeguí las instrucciones que se encuentran en el mail para validar tu cuenta.";
